import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BaseNetworkStatusService {
  private _isOnline$ = new BehaviorSubject<boolean>(navigator.onLine);
  isOnline$ = this._isOnline$.asObservable();

  constructor(private zone: NgZone) {
    window.addEventListener('online', () => this.zone.run(() => this._isOnline$.next(true)));
    window.addEventListener('offline', () => this.zone.run(() => this._isOnline$.next(false)));
  }
}
